export const isCountryOfResidenceValid = (passengerList: Array<any>) => {
  return passengerList.every(
    p => p.countryOfResidence !== null && p.countryOfResidence !== undefined && p.countryOfResidence !== ""
  );
};
